export const searchTermsForward = (value: string | undefined) => value
  ? value.split('')
    .reduce((acc: string[], item): string[] => {
      acc.length
        ? acc.push(acc[acc.length - 1] + item)
        : acc.push(item);
      return acc;
    }, [])
  : [];

export const searchTermsBackward = (value: string | undefined) => value
  ? value.split('').reverse()
    .reduce((acc: string[], item): string[] => {
      acc.length
        ? acc.push(item + acc[acc.length - 1])
        : acc.push(item);
      return acc;
    }, [])
  : [];

export const searchTerms = (values: any) => {
  const terms = values?.map((value: string) =>
    value.split(' ').map(val => [
      ...searchTermsForward(val.toLowerCase()),
      ...searchTermsBackward(val.toLowerCase()),
    ])).flat().flat();

  const terms2 = values?.map((value: string) =>
    [
      ...searchTermsForward(value.toLowerCase()),
      ...searchTermsBackward(value.toLowerCase()),
    ]).flat();

  return Array.from(new Set([...terms, ...terms2]));
};

export const addTagsToSearchTerms =
  (existingSearchTerms: any[] | string[] | undefined = [], tags: any[]) => {
    const tagSearchTerms = searchTerms(tags);
    return existingSearchTerms.concat(tagSearchTerms);
  };
